import React from 'react'
import { ASSETS_ENDPOINT } from '../../../../../config'

const FlightOfferForm = (props) => {
    const logoUrl = props.airlineLogo && typeof props.airlineLogo === "string"
        ? (props.airlineLogo.startsWith("http") ? props.airlineLogo : ASSETS_ENDPOINT + "/" + props.airlineLogo)
        : ""

    return (
        <form>
            <div className="inputs">
                <div className="row">
                    <div className="form-label"><label>Airline Name</label></div>
                    <div className="form-input">
                        <input type="text" name="airlineName" value={props.airlineName} onChange={props.onChange} />
                        <span className="error">{props.errors.airlineName}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Airline Logo</label></div>
                    <div className="form-input">
                        {logoUrl.length > 0 && <img alt="" src={logoUrl} style={{ maxWidth: "160px", display: "block", marginBottom: "8px", borderRadius: "6px" }} />}
                        <input
                            type="file"
                            name="airlineLogo"
                            accept=".jpg,.jpeg,.png,.webp,.svg"
                            onChange={(e) => {
                                if (e.target.files.length === 0) {
                                    return
                                }
                                props.onChange({
                                    target: {
                                        name: "airlineLogo",
                                        value: e.target.files[0]
                                    }
                                })
                            }}
                        />
                        <span className="error">{props.errors.airlineLogo}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Departure Code</label></div>
                    <div className="form-input">
                        <input type="text" name="departureCode" value={props.departureCode} onChange={props.onChange} />
                        <span className="error">{props.errors.departureCode}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Departure City</label></div>
                    <div className="form-input">
                        <input type="text" name="departureCity" value={props.departureCity} onChange={props.onChange} />
                        <span className="error">{props.errors.departureCity}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Arrival Code</label></div>
                    <div className="form-input">
                        <input type="text" name="arrivalCode" value={props.arrivalCode} onChange={props.onChange} />
                        <span className="error">{props.errors.arrivalCode}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Arrival City</label></div>
                    <div className="form-input">
                        <input type="text" name="arrivalCity" value={props.arrivalCity} onChange={props.onChange} />
                        <span className="error">{props.errors.arrivalCity}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Trip Type</label></div>
                    <div className="form-input">
                        <select
                            name="tripType"
                            value={props.tripType}
                            onChange={(e) => props.onChange({ target: { name: "tripType", value: Number(e.target.value) } })}
                        >
                            <option value={0}>One Way</option>
                            <option value={1}>Return</option>
                        </select>
                        <span className="error">{props.errors.tripType}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Price</label></div>
                    <div className="form-input">
                        <input type="number" name="price" value={props.price} onChange={props.onChange} />
                        <span className="error">{props.errors.price}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Currency</label></div>
                    <div className="form-input">
                        <input type="text" name="currency" value={props.currency} onChange={props.onChange} />
                        <span className="error">{props.errors.currency}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Badge</label></div>
                    <div className="form-input">
                        <select
                            name="badge"
                            value={props.badge}
                            onChange={(e) => props.onChange({ target: { name: "badge", value: Number(e.target.value) } })}
                        >
                            <option value={0}>None</option>
                            <option value={1}>Available</option>
                            <option value={2}>Promotion</option>
                            <option value={3}>Fast Selling</option>
                        </select>
                        <span className="error">{props.errors.badge}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label"><label>Status</label></div>
                    <div className="form-input">
                        <select
                            name="status"
                            value={props.status}
                            onChange={(e) => props.onChange({ target: { name: "status", value: Number(e.target.value) } })}
                        >
                            <option value={0}>Draft</option>
                            <option value={1}>Published</option>
                            <option value={2}>Archived</option>
                        </select>
                        <span className="error">{props.errors.status}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="submit" onClick={props.onSubmit}>{props.action}</button>
                <button type="reset" onClick={props.onCancel}>Cancel</button>
            </div>
        </form>
    )
}

export default FlightOfferForm
